import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import { Import } from "lucide-react";
import { getIndexColumn } from "../../../utils/getIndexColumn";

/**
 * Мөр бүрийн үйлдлийн багана — засах / устгах / үнийн файл хуулах.
 * Файл хуулах товч зөвхөн B2B хэрэглэгчид харагдана.
 */
const getActionColumn = ({ isB2B, onEdit, onDelete, onImport, editLoadingId, uploadingId }) => ({
  title: "",
  key: "action",
  width: isB2B ? 132 : 96,
  align: "center",
  fixed: "right",
  render: (_, record) => (
    <div className="client_action_buttons">
      <Tooltip title="Засах">
        <Button
          type="text"
          className="client_action_edit"
          icon={<EditOutlined />}
          loading={Boolean(editLoadingId) && editLoadingId === record?._id}
          onClick={() => onEdit(record?._id)}
        />
      </Tooltip>
      <Tooltip title="Устгах">
        <Button
          type="text"
          danger
          icon={<DeleteOutlined />}
          onClick={() => onDelete(record?._id)}
        />
      </Tooltip>
      {isB2B ? (
        <Tooltip title="Үнийн файл хуулах">
          <Button
            type="text"
            icon={<Import size={18} />}
            loading={Boolean(uploadingId) && uploadingId === record?._id}
            onClick={() => onImport(record)}
          />
        </Tooltip>
      ) : null}
    </div>
  ),
});

export const getColumns = ({
  getColumnSearchProps,
  pagination,
  isB2B,
  onEdit,
  onDelete,
  onImport,
  editLoadingId,
  uploadingId,
}) => [
    getIndexColumn(pagination.current, pagination.pageSize),
    {
      title: "Нэр",
      dataIndex: "name",
      key: "name",
      ...getColumnSearchProps("name", "Нэр"),
      render: (name) => name || "-",
      width: 220,
    },
    {
      title: "Утасны дугаар",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
      ...getColumnSearchProps("phoneNumber", "Утасны дугаар"),
      render: (phoneNumber) => phoneNumber || "-",
      width: 220,
    },
    {
      title: "И-Мэйл",
      dataIndex: "email",
      key: "email",
      ...getColumnSearchProps("email", "И-Мэйл"),
      render: (email) => email || "-",
      width: 220,
    },
    {
      title: "Хаяг",
      dataIndex: "address",
      key: "address",
      // address нь [{ name }] хэлбэрийн массив — аймаг/сум/баг гэсэн дэс дараатай
      render: (address) =>
        (address ?? [])
          .map((el) => el?.name)
          .filter(Boolean)
          .join(", ") || "-",
      width: 260,
    },
    {
      title: "Дэлгэрэнгүй хаяг",
      dataIndex: "addressDetail",
      key: "addressDetail",

      render: (addressDetail) => addressDetail || "-",
      width: 240,
    },
    {
      title: "Тайлбар",
      dataIndex: "description",
      key: "description",
      render: (description) => description || "-",
      width: 200,
    },
    getActionColumn({ isB2B, onEdit, onDelete, onImport, editLoadingId, uploadingId }),
  ];
